import { EffectRepository } from '@/modules/effects/domain/EffectRepository'
import { JobRepository } from '@/modules/jobs/domain/JobRepository'
import { EffectListScreenData } from '@/modules/effects/domain/EffectListScreenData'
import { EffectFilters } from '../domain/EffectFilters'
import { CompanyEffectsConfiguration } from '@/modules/effects/domain/CompanyEffectsConfiguration'
import { FileRepository } from '@/modules/shared/domain/FileRepository'

export class EffectsComponent{    
    effects_repo:EffectRepository
    jobs_repo:JobRepository   
    screen_data: EffectListScreenData
    file_repo: FileRepository
  
    constructor(effects_repo, jobs_repo, screen_data, file_repo){
        this.effects_repo = effects_repo
        this.jobs_repo = jobs_repo              
        this.screen_data = screen_data
        this.file_repo = file_repo
    }
  
    async get_effects(company_id, filters){        
        this.screen_data.setLoading(true)
        /*console.log('----------------> ', filters)*/

        let filt = null;
        if (filters) {
            filt = new EffectFilters(
                filters.state.value,
                filters.concept.value,
                filters.effect_type.value,
                filters.date_from.value,
                filters.date_to.value,
                filters.origin.value,
                filters.account.value,
                filters.total_amount.value,
                filters.total_amount_from.value,
                filters.total_amount_to.value
            )
        }

        let effects = await this.effects_repo.filter_by_company_id(company_id, filt)
        if (effects.length > 0){
            this.screen_data.setShowSelectEffects(true)
        }
        else {
            this.screen_data.setShowSelectEffects(false)
        }
        this.screen_data.setEffects(effects)
        this.screen_data.setLoading(false)
    }

    async import_effects(company_id, min_date, max_date){
        this.screen_data.setLoadingImportEffects(true);
        let job_id = await this.effects_repo.import_effects(company_id, min_date, max_date);        
        this.screen_data.setImportEffectsJobId(job_id);
        this.screen_data.setImportEffectsJobState('running');
        this.screen_data.success_message('Sincronizando efectos de inmatic')
    }

    async import_effects_done(company_id, is_error = false){
        let job = await this.jobs_repo.find_by_id(this.screen_data.importEffectsJobId)        
        this.screen_data.setImportEffectsJobState(job.state);
        
        this.screen_data.setLoadingImportEffects(false);
        this.screen_data.setLoadingUploadEffects(false);
        
        // Verificar si el output tiene status: 'error'
        const hasErrorInOutput = job.output_info && job.output_info.status === 'error';
        
        if (is_error || this.screen_data.importEffectsJobState == 'error' || hasErrorInOutput) {
            const errorMsg = hasErrorInOutput && job.output_info.error_message 
                ? job.output_info.error_message 
                : 'Error al procesar los efectos.';
            this.screen_data.error_message(errorMsg)
        } else if (this.screen_data.importEffectsJobState == 'done') {
            //this.$refs.effectsTable.refresh_data();
            this.get_effects(company_id, null)
            this.screen_data.success_message('Efectos cargados correctamente.')
        }
    }

    async delete_effects(effects_ids, company_id, filters){
        this.screen_data.setLoading(true)
        await this.effects_repo.delete(effects_ids)
        this.get_effects(company_id, filters)
        this.screen_data.setLoading(false)
    }

    async mark_effects_as_manually_checked(effects_ids, company_id, filters){
        this.screen_data.setLoading(true)
        let result = await this.effects_repo.toggle_manual_check(effects_ids, true)
        this.get_effects(company_id, filters)
        this.screen_data.setLoading(false)
        if (result && result.status === 'error') {
            this.screen_data.error_message(result.error_message)
        } else {
            this.screen_data.success_message('Efectos marcados como punteados manualmente')
        }
    }

    async unmark_effects_as_manually_checked(effects_ids, company_id, filters){
        this.screen_data.setLoading(true)
        let result = await this.effects_repo.toggle_manual_check(effects_ids, false)
        this.get_effects(company_id, filters)
        this.screen_data.setLoading(false)
        if (result && result.status === 'error') {
            this.screen_data.error_message(result.error_message)
        } else {
            this.screen_data.success_message('Efectos despunteados correctamente')
        }
    }

    async import_effects_accounting_program(company_id, min_date, max_date){
        this.screen_data.setLoadingImportEffectsAccountingProgram(true)        
        // Solo mismo year
        if (min_date.substring(0,4) == max_date.substring(0,4)) { 
            await this.effects_repo.import_effects_accounting_program(company_id, min_date, max_date);
            this.screen_data.setLoadingImportEffectsAccountingProgram(false)
            this.screen_data.success_message('Los efectos del programa contable se estan importando.')     
        } else {
            this.screen_data.setLoadingImportEffectsAccountingProgram(false)
            this.screen_data.error_message('Deben ser del mismo año la fechas') 
        }
         
    }

    async upload_effects(company_id, file) {
        this.screen_data.setLoadingUploadEffects(true)
        let file_path = await this.file_repo.uploadFile(file)
        let job_id = await this.effects_repo.upload_effects_file(company_id, file_path, file.name)
        this.screen_data.dialog_upload_excel = false
        this.screen_data.setImportEffectsJobId(job_id);
        this.screen_data.setImportEffectsJobState('running');
    }

    async update_effects_configuration(company_id, effects_origin, automatic_effects_inmatic) {
        this.screen_data.setLoadingUpdateConfiguration(true)
        if (automatic_effects_inmatic === undefined) {
            automatic_effects_inmatic = false
        }
        await this.effects_repo.update_effects_configuration(company_id, new CompanyEffectsConfiguration(effects_origin, automatic_effects_inmatic))
        this.screen_data.setLoadingUpdateConfiguration(false)
    }

    async get_effects_configuration(company_id) {
        let effects_config = await this.effects_repo.get_effects_configuration(company_id)
        if (effects_config) {
            this.screen_data.setEffectsOriginConfig(effects_config.effects_origin)
            this.screen_data.setAutomaticEffectsInmaticConfig(effects_config.automatic_effects_inmatic)
        }        
    }

    async add_effect_manual(company_id, effect, filters) {
        this.screen_data.setLoadingCreateEffect(true)
        await this.effects_repo.create_effect_manual(company_id, effect.amount,effect.account, effect.concept, effect.effect_type, effect.invoice_number, effect.date)                

        this.screen_data.setLoading(true)        
        this.get_effects(company_id, filters)
        this.screen_data.setLoading(false)

        this.screen_data.resetNewEffect()
        this.screen_data.setLoadingCreateEffect(false)
    }
  }